import { Box, FormControl, FormControlLabel, InputAdornment, Radio, RadioGroup, TextField } from "@mui/material";
import { CurrencyJSON } from "../../../../common/const";

const CommonVariant = ({
    type,
    projectData,
    label,
    onRadioChange,
    onInputChange,
    helperText,
    val,
    disabled
}) => {
    return (
        <Box display="flex" gap={1}>
            <Box>
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={type}
                        name="radio-buttons-group"
                        onChange={(e) => onRadioChange(e)}
                    >
                        <FormControlLabel value="value" control={<Radio />} label={CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} />
                        <FormControlLabel value="rate" control={<Radio />} label="%" />
                    </RadioGroup>
                </FormControl>
            </Box>
            <Box>
                <TextField
                    id="standard-basic"
                    label={label}
                    variant="standard"
                    type="number"
                    fullWidth
                    value={val || ''}
                    onChange={(e) => onInputChange(e)}
                    slotProps={{
                        input: {
                            startAdornment: type !== 'rate' && <InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>,
                            endAdornment: type === 'rate' && <InputAdornment position="end">%</InputAdornment>,
                        },
                    }}
                    sx={{
                        '& .MuiInputBase-root': { fontSize: '0.85rem' },
                        '& .MuiInputLabel-root': { fontSize: '0.8rem' },
                        '& .MuiFormHelperText-root': { fontSize: '0.55rem' },
                    }}
                    helperText={helperText}
                    disabled={disabled}
                />
            </Box>
        </Box>
    )
}

export default CommonVariant;